import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import { Button, Text } from '@beef/ui-kit';
import { Icon } from 'components';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const ChildNumber = ({
  ctn,
  image,
  children,
  onClick,
  iconName,
}) => (
  <div className={cn('item')}>
    <div className={cn('item__image')}>
      <img src={image} alt="аватар" className={cn('image')} />
    </div>
    <div className={cn('item__number')}>
      <Text size="size5-m">
        {ctn}
      </Text>
    </div>
    <div className={cn('item__status')}>
      {children}
    </div>
    <div className={cn('item__icon')}>
      <Button variant="plain" onClick={onClick}>
        <Icon name={iconName} />
      </Button>
    </div>
  </div>
);

ChildNumber.propTypes = {
  iconName: PropTypes.string,
  ctn: PropTypes.string,
  image: PropTypes.string,
  onClick: PropTypes.func,
};

export { ChildNumber };
